import React from "react";
import { motion } from "framer-motion";
import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";
import SectionTitle from "./ui/SectionTitle";

const WhySection = () => {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <motion.section
      className="mx-auto max-w-6xl px-6 py-10"
      initial={prefersReducedMotion ? false : { y: 12 }}
      whileInView={{ y: 0 }}
      viewport={{ once: true }}
    >
      <SectionTitle variant="h2" className="mb-6">
        Find something worth watching
      </SectionTitle>
      <div className="grid gap-6 sm:grid-cols-3">
        <div>
          <h3 className="text-h3 font-display">Upcoming scripted TV</h3>
          <p className="mt-2 text-body text-muted-foreground">
            New shows and returning seasons from streaming services and
            broadcasters. Returning shows need a rating of at least 7.0 on IMDb,
            or the listing service when IMDb has none.
          </p>
        </div>
        <div>
          <h3 className="text-h3 font-display">Recommendations with reasons</h3>
          <p className="mt-2 text-body text-muted-foreground">
            Start with a show you like. Every pick explains the mood, humour,
            pace or characters that connect it to your favourite.
          </p>
        </div>
        <div>
          <h3 className="text-h3 font-display">Search the archive</h3>
          <p className="mt-2 text-body text-muted-foreground">
            Describe what you want to watch, or browse past premiere months.
            Show descriptions reflect the published listings.
          </p>
        </div>
      </div>
      <a
        href="/about"
        className="mt-6 inline-flex min-h-11 items-center text-primary underline underline-offset-4"
      >
        About PremiereLens
      </a>
    </motion.section>
  );
};
export default WhySection;
